import './simple-css.css'

const SimpleCss = () => {
    const boxStyle = {
        width: 100,
        height: 100,
        padding: 10,
    }
    return (
        <div>
            <div style={{ textAlign: 'left' }}>
                <h1>CSS: Simple Selectors</h1>
                <p>The code on the right assigns a class called "spinny" to the first element matching the CSS selector provided in the "selector" variable, which then makes the element spin</p>
                <p>We want the <strong>blue</strong> box to spin, but unfortunately the CSS selector ".box" makes the <strong>red</strong> box spin.</p>
                <p><strong>Click the "RUN" button to see the red box spin.</strong></p>
                <p>Change the CSS selector to make <span style={{fontWeight: 600, fontStyle:'italic'}}>only</span> the blue box spin.</p>
                <p>Click "RUN" again to test if your solution worked</p>

            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 20, padding: 16 }}>
                <div id="red-box" className="box" style={Object.assign({}, boxStyle, { backgroundColor: 'red' })}>

                </div>
                <div id="blue-box" className="box" style={Object.assign({}, boxStyle, { backgroundColor: 'blue' })}>

                </div>
            </div>

        </div >);
}

export default SimpleCss;